import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import * as S from "./styles";
import AuthenticationContext from "@context/AuthenticationContext";
import NoNavLayout from "@layouts/NoNavLayout";
import { processError } from "@util/processError";
import UnAuthenticatedPage from "@templates/UnAuthenticatedPage";
import { Track } from "@util/analytics";
import { useRouter } from "next/router";
import { theme } from "@constants/theme";
import WelcomeScrollingAnimation from "./welcome-scrolling-animation.json";

const CreateAccountContainer = ({
  isPartner,
  submitRedirect,
  authRedirect,
  meta,
  loginLink,
}) => {
  const [serverErrors, setServerErrors] = useState(null);
  const [userCreatedAccount, setUserCreatedAccount] = useState(false);
  const { register } = useContext(AuthenticationContext) || {
    register: null,
  };
  const router = useRouter();

  const handleSubmit = async (data) => {
    try {
      // Flag to handle unauthenticated page redirect
      setUserCreatedAccount(true);

      await register(data);

      // create account successful
      Track("User Signed Up");

      // redirect to submit link
      router.push(submitRedirect);
    } catch (e) {
      setServerErrors(processError(e));
    }
  };

  return (
    <UnAuthenticatedPage
      redirectTo={authRedirect}
      disableAuthRedirect={userCreatedAccount}
    >
      <NoNavLayout
        meta={meta}
        backgroundColor={theme.colors.brand.accent_secondary}
        logoColor={theme.colors.brand.primary}
        withStripes={false}
      >
        <S.CreateAccountContainer_div data-cy={"create-account-container"}>
          <S.MagicText_h1 type="caption1Bold" element="h1">
            <S.Text_span>Tackle</S.Text_span>
            <S.MagicImage_lottie
              src={WelcomeScrollingAnimation}
              loop={true}
              alt="taxes, net worth, sleep, insurance, budget, meal prepping, career growth"
            />
            <S.Text_span>in 10 minutes</S.Text_span>
          </S.MagicText_h1>
          <S.CreateAccountForm_div
            onSubmit={handleSubmit}
            serverErrors={serverErrors}
            loginLink={loginLink}
          />
        </S.CreateAccountContainer_div>
      </NoNavLayout>
    </UnAuthenticatedPage>
  );
};

CreateAccountContainer.propTypes = {
  isPartner: PropTypes.bool.isRequired,
  submitRedirect: PropTypes.string.isRequired,
  authRedirect: PropTypes.string.isRequired,
  meta: PropTypes.shape({
    title: PropTypes.string.isRequired,
  }),
  loginLink: PropTypes.string.isRequired,
};

export default CreateAccountContainer;
